import { render, staticRenderFns } from "./EdicionVacaciones.vue?vue&type=template&id=ef6f65b4"
import script from "./EdicionVacaciones.vue?vue&type=script&lang=js"
export * from "./EdicionVacaciones.vue?vue&type=script&lang=js"
import style0 from "./EdicionVacaciones.vue?vue&type=style&index=0&id=ef6f65b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports